<template>
  <div>
    <div class="form-group mb-0">
      <label class="sr-only" for="email">Email</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text text-center"><font-awesome-icon :icon="{ prefix: 'fa', iconName: 'at' }"/></div>
        </div>
        <input type="email" :class="($v.email.$error)?'form-control is-invalid':'form-control'" id="email" placeholder="E-mail" name="email" v-model="email" required autofocus>
        <form-validation-invalid-feedback :field="$v.email" :text="{ email: 'Campo deve ser um email', required: 'Obrigatório informar o email' }" />
      </div>
    </div>

    <div class="form-group">
      <label class="sr-only" for="senha">Senha</label>
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text text-center"><font-awesome-icon :icon="{ prefix: 'fa', iconName: 'unlock-alt' }"/></div>
        </div>
        <input type="password" :class="($v.password.$error)?'form-control is-invalid':'form-control'"  id="senha" placeholder="Senha" name="senha" v-model="password" required>
        <form-validation-invalid-feedback :field="$v.password" :text="{ required: 'Obrigatório informar a senha' }" />
      </div>
    </div>
    
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import FormValidationInvalidFeedback from '@/components/formValidationInvalidFeedback'

export default {
  name: 'UserAndPassword',
  components : {FormValidationInvalidFeedback},
  validations: {
    password: { required },
    email: { required, email }
  },
  computed: {
    email: {
      get () {
        return this.$store.getters.emailLogin
      },
      set (value) {
        this.$store.commit('setEmailLogin', value)
      }
    },
    password: {
      get () {
        return this.$store.getters.passwordLogin
      },
      set (value) {
        this.$store.commit('setPasswordLogin', value)
      }
    }
  }
}
</script>